import { COLORS } from '@/constants';
import styled from 'styled-components';

export const ContactBox = styled.div`
  background: ${COLORS.white};
  border-radius: 6px;
  border: 1px solid ${COLORS['neutral/300']};
  overflow: hidden;
`;

export const ContactBoxHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: ${COLORS['neutral/50']};
  border-bottom: 1px solid ${COLORS['neutral/300']};
`;

export const ContactTitle = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: ${COLORS['primary/900']};
`;

export const DescriptionText = styled.p`
  font-size: 14px;
  color: ${COLORS['neutral/600']};
  line-height: 1.6;
  margin: 0;
`;

export const ContactBoxBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px 16px;
`;

export const ContactRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

export const ContactIconBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  border-radius: 6px;
  background: ${COLORS['primary/50']};
`;

export const ContactTextBlock = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContactLabel = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
  color: ${COLORS['primary/500']};
`;

export const ContactValue = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 1.3;
  color: ${COLORS['primary/900']};
`;

export const ContactLink = styled.a`
  font-size: 14px;
  font-weight: 600;
  line-height: 1.3;
  color: ${COLORS['primary/900']};
  text-decoration: none;

  &:visited {
    color: ${COLORS['primary/900']};
  }

  &:hover {
    color: ${COLORS['secondary/500']};
    text-decoration: underline;
  }
`;
